import React from 'react';

import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/new';
import RovoChatIcon from '@atlaskit/icon/core/rovo-chat';
import { fg } from '@atlaskit/platform-feature-flags';
import { usePublish } from '@atlaskit/rovo-triggers/main';

import { i18n } from './messages';

export type SummarizeInChatProps = {
	url: string | undefined;
	ari: string | undefined;
	testId?: string;
	onClick?: () => void;
	/**
	 * Spacing for the underlying Atlaskit Button. Defaults to `'compact'` to
	 * preserve existing per-row hover behavior. Pass `'default'` to render the
	 * standard 32px-tall secondary button (e.g. when sitting alongside the
	 * Related links footer toggle).
	 */
	spacing?: 'compact' | 'default';
};

export const SummarizeInChatButton = ({
	url,
	ari,
	testId,
	onClick,
	spacing = 'compact',
}: SummarizeInChatProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const publish = usePublish('ai-mate');

	const promptRovoChat = (e: React.MouseEvent<HTMLButtonElement>) => {
		onClick?.();
		e.stopPropagation();

		if (!url) {
			return;
		}

		publish({
			type: 'browser-context-payload',
			source: 'search-result',
			data: {
				context: {
					browserUrl: url,
				},
			},
		});
		publish({
			type: 'chat-new',
			source: 'search-result',
			data: {
				dialogues: [],
				prompt: `Summarize ${url}`,
				name: `Summarize ${url}`,
				...(ari && fg('read_fe_search_artifact_context')
					? {
							searchArtifact: {
								url,
								ari,
							},
						}
					: {}),
			},
		});
	};

	return (
		<Button iconBefore={RovoChatIcon} spacing={spacing} onClick={promptRovoChat} testId={testId}>
			{formatMessage(i18n.summarizeInChatButtonText)}
		</Button>
	);
};
